import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common',
  templateUrl: 'common.component.html'
})

export class CommonComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
